export enum LocalStorageKey {
  OnlineTheme = 'onlineShare.theme',
  UserTheme = 'user.theme',
  HiddenTopNotificationIds = 'explore.project.hiddenTopBulletins',
  SAMPLE_CODE_SELECTED_LANGUAGE_VARIANT = 'explorer.sampleCodeSelectedLanguageVariant',
  BEGINNER_TIPS_CLOSED_PREFIX = 'beginnerTipsClosed',
  USE_ENVIRONMENT = 'explore.local.environmentsMap',
  USE_ENVIRONMENT_ID = 'explore.local.environmentIdMap',
  USE_ENVIRONMENT_VAR_IN_URL_MAP_BY_DOCS_ID = 'docsSite.local.environmentVarInURLMap',
  ACCESS_TOKEN = 'common.accessToken',
}
